import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, AutomationInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable, of } from 'rxjs';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../../common/automation-display.service';

@Injectable({ providedIn: 'root' })
export class CreateProjectInTaskManagerForOrderService extends AutomationDisplayService {
  constructor(protected readonly translateService: TranslateService) {
    super();
  }

  getActivityColumn(
    namespace: string,
    activity: ActivityInterface,
    automation: AutomationInterface,
  ): ActivityTableEntry {
    const data = activity.workflowStep?.data ? JSON.parse(activity.workflowStep.data) : {};
    return this.tableEntry(
      this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.CREATE_PROJECT_IN_TASK_MANAGER_FOR_ORDER.ACTIVITY', {
        templateName: data.title,
      }),
      this.getDefaultStepColumnBody(namespace, activity.workflowStep, automation),
    );
  }

  getActivitySubtitle(_namespace: string, _activity: ActivityInterface): Observable<string> {
    return of('');
  }

  getAutomationNodeData(
    _namespace: string,
    step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    const data = step?.data ? JSON.parse(step.data) : {};
    if (data.template_id) {
      return this.nodeDisplayData(
        this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.CREATE_PROJECT_IN_TASK_MANAGER_FOR_ORDER.ACTION', {
          templateName: data.title,
        }),
        this.noValidationErrorsDetected(),
      );
    } else {
      return this.nodeDisplayData(
        this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.CREATE_PROJECT_IN_TASK_MANAGER_FOR_ORDER.TEMPLATE'),
        this.validationErrorsDetected(step, '', true),
      );
    }
  }

  getTemplateNodeData(
    _namespace: string,
    step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    const data = step?.data ? JSON.parse(step.data) : {};
    if (data.title) {
      return this.nodeDisplayData(
        this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.CREATE_PROJECT_IN_TASK_MANAGER_FOR_ORDER.ACTION', {
          templateName: data.title,
        }),
        this.noValidationErrorsDetected(),
      );
    } else {
      return this.nodeDisplayData(
        this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.CREATE_PROJECT_IN_TASK_MANAGER_FOR_ORDER.TEMPLATE'),
        this.noValidationErrorsDetected(),
      );
    }
  }

  getTemplateActionSubtitle(_namespace: string, step: WorkflowStepInterface): Observable<string> {
    const data = step?.data ? JSON.parse(step.data) : {};
    if (data.title) {
      return this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.CREATE_PROJECT_IN_TASK_MANAGER_FOR_ORDER.ACTION', {
        templateName: data.title,
      });
    } else {
      return this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.CREATE_PROJECT_IN_TASK_MANAGER_FOR_ORDER.TEMPLATE');
    }
  }
}
